var React = require('react');

function Shape2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m102.376 129.53c-11.2083 3.105-23.7372 3.521-35.4462 3.465-20.9698-.11-44.8321-2.065-57.77835-18.52-10.7074-13.627-10.137291-32.7587-7.63426-49.8932 3.18441-21.6539 10.20681-45.2071 29.00741-56.50541 10.2624-6.16899 22.6246-7.721644 34.5974-8.0404917 26.4346-.6931473 52.925 8.5672917 62.909 35.1149017 4.687 14.2511 8.664 30.4153 8.956 45.4289.25 12.8092-3.073 26.1593-11.695 35.6553-6.16 6.793-14.128 10.869-22.916 13.295z","fill":"#eb614e"}));
}

Shape2.defaultProps = {"fill":"none","height":"133","viewBox":"0 0 137 133","width":"137"};

module.exports = Shape2;

Shape2.default = Shape2;
